<template>
  <interact resizable :resizeOption="resizeOption" :data-app-theme="$store.getters.theme" draggable :dragOption="dragOption"
    class="resize-drag" :style="style" @dragmove="dragmove" @resizemove="resizemove"
    :class="{ fullscreen: $store.getters.isFullscreenMail }">
    <form @submit.prevent="sendEmail" class="mail-compose" id="container"
      :class="{ fullscreen: $store.getters.isFullscreenMail }" :aria-busy="sending">
      <header class="top-bar app-toolbar" @dblclick.self="$store.commit('toggleFullscreenMail')">
        <div class="triple-button">
          <button type="button" class="traffic red" aria-label="Close Mail" @click="closeMail"></button>
          <button type="button" class="traffic yellow" aria-label="Minimize Mail" @click="closeMail"></button>
          <button type="button" class="traffic green" aria-label="Toggle fullscreen" @click="$store.commit('toggleFullscreenMail')"></button>
        </div>
        <h2>New Message</h2>
        <button type="submit" class="send-button" :disabled="sending">
          <i class="far fa-paper-plane" aria-hidden="true"></i> {{ sending ? 'Sending…' : 'Send' }}
        </button>
      </header>
      <div class="compose-content">
        <div class="field-row"><span class="field-label">To</span><span class="recipient">Jay Martinez</span></div>
        <div class="field-row">
          <label for="mail-email" class="field-label">From</label>
          <input id="mail-email" name="email" type="email" autocomplete="email" placeholder="you@example.com"
            v-model="mailSender" @input="onChangeMailSender" required :disabled="sending" />
        </div>
        <div class="field-row">
          <label for="mail-subject" class="sr-only">Subject</label>
          <input id="mail-subject" name="subject" placeholder="Subject"
            v-model="mailSubject" @input="onChangeMailSubject" required :disabled="sending" />
        </div>
        <div class="message-field">
          <label for="mail-message">Message</label>
          <textarea id="mail-message" name="message"
            v-model="mailContent" @input="onChangeMailContent" required :disabled="sending"></textarea>
        </div>
      </div>
      <footer>
        <p v-if="submissionStatus" role="status" :class="{ 'submission-error': submissionError }">{{ submissionStatus }}</p>
        <p v-else>Your message will be sent to Jay’s inbox.</p>
      </footer>
      <div class="resizer resizer-b"></div><div class="resizer resizer-l"></div>
      <div class="resizer resizer-t"></div><div class="resizer resizer-r"></div>
    </form>
  </interact>
</template>

<style scoped>
.resize-drag { --mail-bg:#fff; --mail-toolbar:#ececef; --mail-line:#dcdde3; --mail-text:#252a37; --mail-muted:#606778; --mail-chip:#dfecff; box-sizing:border-box; position:sticky; width:700px; max-width:90vw; height:560px; max-height:calc(100vh - 150px); min-width:420px; min-height:320px; user-select:auto; touch-action:auto; }
.resize-drag[data-app-theme="dark"] { --mail-bg:#242426; --mail-toolbar:#323235; --mail-line:#45454b; --mail-text:#f2f2f5; --mail-muted:#b8bac5; --mail-chip:#263f60; }
.mail-compose { position:relative; display:flex; flex-direction:column; box-sizing:border-box; width:100%; height:100%; border:1px solid var(--mail-line); border-radius:14px; background:var(--mail-bg); color:var(--mail-text); overflow:hidden; box-shadow:0 16px 48px #0003; margin:0; }
.top-bar { box-sizing:border-box; width:100%; height:52px; display:flex; align-items:center; gap:16px; padding:0 18px; background:var(--mail-toolbar); border-bottom:1px solid var(--mail-line); flex-shrink:0; }
.top-bar h2 { font-size:16px; font-weight:600; flex:1; text-align:center; margin:0; color:var(--mail-text); }
.triple-button { display:flex; gap:8px; width:auto; padding:0; flex-shrink:0; }
.traffic { width:12px; height:12px; border:0; border-radius:50%; padding:0; cursor:pointer; }
.red { background:#ff5f57; } .yellow { background:#febc2e; } .green { background:#28c840; }
.send-button { flex-shrink:0; white-space:nowrap; display:flex; align-items:center; gap:8px; background:#0071e3; color:#fff; border:0; border-radius:9px; padding:8px 14px; font:inherit; font-size:14px; font-weight:600; cursor:pointer; }
.send-button:disabled { opacity:.65; cursor:wait; }
.compose-content { padding:4px 24px 24px; flex:1; min-height:0; overflow:auto; display:flex; flex-direction:column; }
.field-row { display:flex; align-items:center; gap:16px; min-height:44px; padding:4px 0; border-bottom:1px solid var(--mail-line); flex-shrink:0; }
.sr-only { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0; }
.field-label { width:auto; flex-shrink:0; font-size:14px; color:var(--mail-muted); }
.recipient { font-size:14px; background:var(--mail-chip); color:var(--mail-text); padding:7px 12px; border-radius:8px; }
input,textarea { box-sizing:border-box; color:var(--mail-text); background:var(--mail-bg); font:inherit; font-size:14px; }
input { border:0; padding:6px 0; flex:1; width:0; min-width:0; }
input::placeholder,textarea::placeholder { color:var(--mail-muted); opacity:1; }
input:focus,textarea:focus { outline:none; box-shadow:none; }
button:focus-visible { outline:2px solid #0071e3; outline-offset:3px; }
.message-field { display:flex; flex-direction:column; flex:1; min-height:160px; gap:12px; padding-top:20px; }
.message-field label { font-size:14px; color:var(--mail-muted); }
textarea { width:100%; flex:1; min-height:120px; border:1px solid var(--mail-line); border-radius:10px; padding:16px; resize:none; line-height:1.6; }
footer { padding:16px 24px; border-top:1px solid var(--mail-line); flex-shrink:0; }
footer p { margin:0; font-size:12px; line-height:1.5; color:var(--mail-muted); }
footer .submission-error { color:#c43030; }
[data-app-theme="dark"] footer .submission-error { color:#ff9d9d; }
.fullscreen { width:100% !important; max-width:100%; height:var(--fullscreen) !important; max-height:var(--fullscreen); }
.resizer { position:absolute; } .resizer-r { right:0; top:60px; bottom:0; width:4px; cursor:ew-resize; } .resizer-l { left:0; top:60px; bottom:0; width:4px; cursor:ew-resize; } .resizer-b { bottom:0; left:0; right:0; height:4px; cursor:ns-resize; }
@media(max-width:600px) { .resize-drag { width:90vw; height:600px; min-width:0; max-height:calc(100vh - 130px); } .top-bar { height:46px; padding:0 12px; gap:10px; } .top-bar h2 { font-size:14px; } .triple-button { gap:5px; } .send-button { padding:8px 10px; font-size:13px; } .compose-content { padding:4px 16px 16px; } .field-row { flex-direction:column; align-items:stretch; gap:5px; padding:8px 0; } .recipient { align-self:flex-start; } input { width:100%; flex:none; padding:7px 10px; border:1px solid var(--mail-line); border-radius:8px; } .message-field { padding-top:16px; } footer { padding:14px 16px; } }
</style>

<script>
import interact from "interactjs";
export default {
  props: {
    // shownProp: Boolean
  },
  data: function () {
    return {
      sending: false,
      submissionStatus: "",
      submissionError: false,
      mailSubject: this.checkMail(),
      mailSender: this.$store.getters.mailSender,
      mailContent: this.$store.getters.mailContent,
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
      resizeOption: {
        edges: { left: true, right: true, bottom: true, top: true },
      },
      dragOption: {
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true,
          }),
        ],
        // ignoreFrom: 'textarea',
        allowFrom: ".top-bar",
        ignoreFrom: "button",
      },
      // values for interact.js transformation
      x: 0,
      y: 0,
    };
  },
  computed: {
    style() {
      return {
        height: `${this.h}px`,
        width: `${this.w}px`,
        transform: `translate(${this.x}px, ${this.y}px)`,
        "--fullscreen": window.innerHeight - 30 + "px",
      };
    },
  },
  methods: {
    async sendEmail() {
      if (this.sending) return;
      this.sending = true;
      this.submissionStatus = "Sending your message…";
      this.submissionError = false;
      try {
        const response = await fetch("https://formsubmit.co/ajax/jaysmartinez@gmail.com", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            email: this.mailSender,
            subject: this.mailSubject,
            message: this.mailContent,
          }),
        });
        const result = await response.json();
        if (!response.ok || ![true, "true"].includes(result.success)) {
          throw new Error("Submission failed");
        }
        this.submissionStatus = "Message submitted. Thank you for getting in touch!";
        this.mailContent = "";
        this.onChangeMailContent();
      } catch (error) {
        this.submissionError = true;
        this.submissionStatus = "Couldn't send your message. Please try again.";
      } finally {
        this.sending = false;
      }
    },
    checkMail() {
      if (this.$store.getters.mailSubject == "New Message") {
        return "";
      } else {
        return this.$store.getters.mailSubject;
      }
    },
    onChangeMailSubject() {
      if (this.mailSubject.replace(/\s/g, "") == "") {
        this.$store.commit("updateMailSubject", "New Message");
      } else {
        this.$store.commit("updateMailSubject", this.mailSubject);
      }
    },
    onChangeMailSender() {
      if (this.mailSender.replace(/\s/g, "") == "") {
        this.$store.commit("updateMailSender", "");
      } else {
        this.$store.commit("updateMailSender", this.mailSender);
      }
    },
    onChangeMailContent() {
      if (this.mailContent.replace(/\s/g, "") == "") {
        this.$store.commit("updateMailContent", "");
      } else {
        this.$store.commit("updateMailContent", this.mailContent);
      }
    },
    dragmove(event) {
      this.x += event.dx;
      this.y += event.dy;
      this.$store.commit("zIndexIncrement", "mail");
    },
    resizemove(event) {
      this.w = event.rect.width;
      this.h = event.rect.height;

      this.x += event.deltaRect.right;
      this.y += event.deltaRect.top;
    },
    dragMouseDown: function (event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function (event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        "px";
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        "px";
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    onClickLog() {
      alert("Hello! I am an alert box!!");
    },
    closeMail(e) {
      e.stopPropagation();
      this.$store.commit("toggleShownMail", false);
      this.$store.commit("changeActiveWindow", "Finder");
    },
  },
  mounted: function () {
    // Query the element
    const ele = document.getElementById("container");

    // The current position of mouse
    let x = 0;
    let y = 0;

    // The dimension of the element
    let w = 0;
    let h = 0;

    const mouseDownHandlerRight = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerRight);
      document.addEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseDownHandlerLeft = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerLeft);
      document.addEventListener("mouseup", mouseUpHandlerLeft);
    };

    const mouseDownHandlerUp = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerUp);
      document.addEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseDownHandlerDown = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerDown);
      document.addEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseMoveHandlerUp = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h - dy}px`;
    };

    const mouseMoveHandlerDown = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h + dy}px`;
    };

    const mouseMoveHandlerRight = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w + dx}px`;
    };

    const mouseMoveHandlerLeft = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w - dx}px`;
    };

    const mouseUpHandlerUp = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerUp);
      document.removeEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseUpHandlerDown = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerDown);
      document.removeEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseUpHandlerRight = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerRight);
      document.removeEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseUpHandlerLeft = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerLeft);
      document.removeEventListener("mouseup", mouseUpHandlerLeft);
    };
    // Query all resizers
    const resizersRight = ele.querySelectorAll(".resizer-r");
    const resizersUp = ele.querySelectorAll(".resizer-t");
    const resizersDown = ele.querySelectorAll(".resizer-b");
    const resizersLeft = ele.querySelectorAll(".resizer-l");

    [].forEach.call(resizersRight, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerRight);
    });

    [].forEach.call(resizersUp, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerUp);
    });

    [].forEach.call(resizersDown, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerDown);
    });

    [].forEach.call(resizersLeft, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerLeft);
    });
  },
};
</script>
